var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"language-control",attrs:{"id":"language-control","dense":"","outlined":"","flat":"","hide-details":"","items":_vm.languages,"item-value":item => item.code,"item-text":item => item.name},model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }